var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fdd-form-item"},[_c('label',{staticClass:"fdd-form-item_label",class:{ 'is-required': _vm.required },style:(`width: ${_vm.labelWidth};`)},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"fdd-form-item_content",style:(`margin-left: ${_vm.labelWidth};`)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }